import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import React from 'react';
import { PageTitleAndSubTitle } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { DataCatalogueMessages } from '../../core-utils/messages/DataCatalogueMessages';
import { scrollBarStyles } from '../../core-utils/messages/CommonConstants';
import DataCatalogueTabs from '../../_components/molecules/DataCatalogueTabs';
import FeatureScreenAccess from '../../_components/organisms/FeatureScreenAccess';
import { isFeatureAccessible } from '../../core-utils/helper-utils/userAccess';
import { useStores } from '../../stores';

export interface DataCataloguePageProps {}

const DataCataloguePage: React.FC<DataCataloguePageProps> = observer(({}) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '1182px',
      padding: '40px 0px 66px 63px',
    },
    flex: {
      display: 'flex',
    },
    scroll: scrollBarStyles,
  });
  const { classes } = useStyles();
  const messages = DataCatalogueMessages;
  const loginPageStore = useStores().loginPageStore;
  const userAccess = loginPageStore.userResponse;
  const combinedScreens = Array.from(
    new Set([
      ...(userAccess.careNavigationScreens || []),
      ...(userAccess.complianceAssuranceScreens || []),
      ...(userAccess.riskManagementScreens || []),
    ]),
  );

  return (
    <Grid container className={classes.root}>
      <FeatureScreenAccess
        noAccess={isFeatureAccessible(
          'DATA_SPHERE',
          combinedScreens,
          userAccess,
        )}
      >
        <PageTitleAndSubTitle
          title={messages.TITLE}
          subTitle={messages.SUBTITLE}
        />
        <DataCatalogueTabs />
      </FeatureScreenAccess>
    </Grid>
  );
});

export default DataCataloguePage;
